import { stringify } from './';
/**
 * Подготавливает входные данные для query params
 * @param params
 */
export function getParamString(params = '') {
    let result = '';
    if (typeof params === 'string') {
        result = params;
    }
    else {
        result = stringify(params);
    }
    if (result.length && result[0] !== '?') {
        result = '?' + result;
    }
    return result;
}
